import React from 'react';
import { Divider } from 'components/UserEvents/style';
import { logEvent } from 'utils/eventTracking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSparkles,
  faMagnifyingGlass
} from '@fortawesome/pro-regular-svg-icons';
import { Flexbox } from '@morressier/ts';

import {
  Description,
  SparklesIcon,
  SparklesIconContainer,
  Title,
  LinkButton,
  MagnifyingGlassIcon,
  CFXContainer
} from './styles';

const title = 'Increase the impact of your research';
const description =
  'Share your research globally. Discover open Call for Abstracts and Papers in your field.';
const searchLink = '/search/all';

const CallForSubmission = () => {
  return (
    <div>
      <Flexbox flexDirection="column" gap={8}>
        <SparklesIconContainer>
          <SparklesIcon icon={faSparkles} />
        </SparklesIconContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Flexbox>
      <CFXContainer>
        <LinkButton
          as="a"
          href={searchLink}
          onClick={() => {
            return logEvent('FIND_CFX_FROM_HOME');
          }}
        >
          <MagnifyingGlassIcon icon={faMagnifyingGlass} /> Find Call for
          Submissions
        </LinkButton>
      </CFXContainer>
      <Divider />
    </div>
  );
};

export default CallForSubmission;
